import { ApiError } from '../../shared/api/ApiClient.js';
import { donationErrorMessage } from '../../shared/api/errorCodes.js';

/**
 * Map buy-again failures to customer-safe copy.
 * Unknown/unmapped ApiError.code must use `fallback` (`account.orders.buyAgainFailed`) —
 * never `err.message` (would leak jargon like "Tenant context missing").
 * Plain Errors are also replaced with `fallback` (buy-again path only).
 * Other callers of donationErrorMessage are unchanged — only this path forces a safe fallback.
 */
export function resolveBuyAgainError(err: unknown, fallback: string): Error {
  if (err instanceof ApiError) {
    const message = donationErrorMessage(err.code, fallback);
    return new ApiError(message, err.status, err.code, err.data, err.retryAfterMs);
  }
  return new Error(fallback);
}
